import isUndefined from 'lodash/isUndefined'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { userTimeZoneFormat } from 'utils/time'
import colors from 'components/utils/colors'
import IconLink from 'components/Shared/IconLink/Index'
import Breadcrumbs from './Breadcrumbs'

const StyledHeader = styled.div`
  padding: ${props => props.withBreadcrumbs ? '56' : '42'}px 0 12px 0;
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  position: relative;
`

const Title = styled.h1`
  font-family: Exo;
  font-size: 40px;
  font-weight: 300;
  line-height: 52px;
  color: ${colors.secondary20};
  margin-right: 30px;
`

const TitlePlainAddition = styled.span`
  font-weight: normal;
  padding-left: 8px;
`

const Subtitle = styled.h2`
  font-size: 12px;
  color: #939393;
  margin-top: 14px;
`

const StyledIcon = styled(IconLink)`
  padding-left: 20px;
`


const Header = ({
  title, titlePlainAddition, descriptionText,
  lastUpdateDate, userTimeZone,
  icon, children, titleRightZone,
  breadcrumbsList,
  className,
}) => {
  const showLastUpdateDate = !isUndefined(lastUpdateDate)
  const { t } = useTranslation()

  return (
    <StyledHeader className={className} withBreadcrumbs={!!breadcrumbsList}>
      <TitleWrapper className='title-wrapper'>
        <div>
          <Title>{title}
            {titlePlainAddition && <TitlePlainAddition>{titlePlainAddition}</TitlePlainAddition>}
          </Title>
          {showLastUpdateDate &&
            <Subtitle>{t('header.lastUpdate')} {userTimeZoneFormat(userTimeZone, lastUpdateDate, 'human')}</Subtitle>
          }
          {descriptionText && <Subtitle>{descriptionText}</Subtitle>}
        </div>

        {icon && icon.onClick && (
          <StyledIcon
            disabled={icon.disabled}
            active={icon.active}
            onClick={() => icon.onClick()}
            iconName={icon.name || (icon.type === 'remove') ? 'icon-remove-big2' : 'icon-add-big'}
            text={icon.text}
          />
        )}

        {titleRightZone}
        {!!breadcrumbsList && <Breadcrumbs entries={breadcrumbsList} />}
      </TitleWrapper>

      {children}
    </StyledHeader>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  titlePlainAddition: PropTypes.string,
  descriptionText: PropTypes.string,
  lastUpdateDate: PropTypes.string,
  userTimeZone: PropTypes.string,
  icon: PropTypes.shape({
    onClick: PropTypes.func,
    type: PropTypes.string,
    text: PropTypes.string,
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    name: PropTypes.string,
  }),
  children: PropTypes.node,
  titleRightZone: PropTypes.node,
  breadcrumbsList: PropTypes.array,
}

export default Header
